module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#bundle",
      toString: function () {
        return this.url;
      }
    }